import * as _4 from 'lodash';
import { CourseSlot } from './../../../../global/builders/ap_generic_slot_builder';
import { RouterHelper } from './../../../../global/helpers/router_helper';
class CourseDetail {
  private genericSlot: CourseSlot;
  constructor(private routerHelper: RouterHelper) {}

  showCourseDetails() {
    return this.routerHelper.findStateAndGo('.course_details', {
      courseDetails: {
        courseNk: this.genericSlot.course.nk,
        termId: this.genericSlot.termId,
        title: this.genericSlot.course._title,
        programSlotId: _4.get(this.genericSlot, 'programSlot.id', null),
        slotType: !_4.isEmpty(this.genericSlot.programSlot)
          ? _4.get(this.genericSlot, 'programSlot.slot_type', null)
          : 'COURSE'
      }
    });
  }
}

angular.module('capability-ng-academic-planner').component('courseDetailComponent', {
  templateUrl:
    'capability-ng-academic-planner/src/plan/components/course_slot_component/course_detail_component/course_detail_component.html',
  controller: CourseDetail,
  bindings: {
    genericSlot: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/course_slot_component/course_detail_component/course_detail_component.ts